import React, { useState, useMemo } from 'react';
import InsightButtonCard from '../InsightButtonCard/InsightButtonCard';
import ExVesselValueModal from '../ExVesselValueModal/ExVesselValueModal';
import type { RegistryComponentProps } from '../../pages/registry/componentRegistry';
import { getRegistryData } from '../../pages/registry/componentRegistry';
import { usePageDataContextOptional } from '../../contexts/PageDataContext';

interface UtilizationCardData {
  title?: string;
  buttonLabel?: string;
  timeSeriesData?: { exvessel?: Array<{ year: number; actual?: number; potential?: number }> };
  loading?: boolean;
  error?: string | null;
}

export default function UtilizationCard(props: RegistryComponentProps): React.ReactElement {
  const [showModal, setShowModal] = useState(false);
  const pageData = usePageDataContextOptional();
  const injectionData = getRegistryData<UtilizationCardData>(props);

  const timeSeriesData =
    (pageData?.data?.timeSeriesData as UtilizationCardData['timeSeriesData']) ??
    injectionData.timeSeriesData;
  const loading = pageData?.loading ?? injectionData.loading ?? false;
  const error = pageData?.error ?? injectionData.error ?? null;
  const title = injectionData.title ?? 'Utilization';
  const buttonLabel = injectionData.buttonLabel ?? 'Historic Utilization';

  const exvesselData = timeSeriesData?.exvessel ?? [];
  const filteredData = useMemo(
    () => exvesselData.filter((item) => item.year <= 2024),
    [exvesselData]
  );

  const handleCloseModal = () => {
    setShowModal(false);
    document.body.style.overflow = 'auto';
  };

  return (
    <>
      <InsightButtonCard
        title={title}
        buttonLabel={buttonLabel}
        onClick={() => setShowModal(true)}
      />
      <ExVesselValueModal
        isOpen={showModal}
        onClose={handleCloseModal}
        data={filteredData}
        loading={loading}
        error={error}
        stockName="All Stocks (Historical)"
      />
    </>
  );
}
